import React, { useState } from 'react';
import { Button, Stack, TextField, Typography } from '@mui/material';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { useGetRequestUrl } from '../hooks/useGetRequestUrl';

export default function Login({ token, setToken }) {
  const requestUrl = useGetRequestUrl();
  const [_, setCookies] = useCookies(['access_token']);
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const handleSubmit = () => {
    axios
      .post(
        `${requestUrl}/auth/login`,
        {
          email: email,
          password: password,
        },
        { withCredentials: false }
      )
      .then(function (response) {
        console.log(response.data);
        setCookies('access_token', response.data.token);
        window.localStorage.setItem('userId', response.data.user._id);
        navigate('/');
      });
  };

  return (
    <Stack justifyContent="center" alignItems="center" spacing={2} mt="100px">
      <Typography fontWeight="700" fontSize="30px">
        Login
      </Typography>
      <TextField
        variant="outlined"
        placeholder="Email"
        value={email}
        onChange={(e) => {
          setEmail(e.target.value);
        }}
      />
      <TextField
        variant="outlined"
        placeholder="Password"
        type="password"
        value={password}
        onChange={(e) => {
          setPassword(e.target.value);
        }}
      />
      <Button onClick={handleSubmit} variant="contained" color="success">
        Login
      </Button>
      <Link
        to="/register"
        style={{ textDecoration: 'underline', color: 'black' }}
      >
        Don't have an account? Register here
      </Link>
    </Stack>
  );
}
